module.exports = __webpack_public_path__ + "img/home.80d08ac3.svg";